/* Measurement illustrations for the four made-to-measure package products. */
(() => {
  const configNode = document.getElementById('wcf-measurement-guide-config');
  if (!configNode) return;

  let images;
  try {
    images = JSON.parse(configNode.textContent);
  } catch {
    return;
  }

  const fieldImages = [
    ['upper arm circumference', 'upperArm'],
    ['hip circumference', 'hip'],
    ['shoulder width', 'shoulder'],
    ['crotch length', 'crotch'],
    ['outseam', 'outseam'],
    ['inseam', 'inseam'],
    ['bust', 'bust'],
    ['waist', 'waist'],
  ];
  const fieldNames = {
    upperArm: 'Upper Arm Circumference',
    hip: 'Hip Circumference',
    shoulder: 'Shoulder Width',
    crotch: 'Crotch Length',
    outseam: 'Outseam',
    inseam: 'Inseam',
    bust: 'Bust',
    waist: 'Waist',
  };

  function imageKeyFor(label) {
    const normalized = String(label || '')
      .toLowerCase()
      .replace(/\([^)]*\)/gu, '')
      .replace(/[^a-z]+/gu, ' ')
      .trim();
    if (normalized.startsWith('height') || normalized.startsWith('weight')) return null;
    return fieldImages.find(([field]) => normalized.startsWith(field))?.[1] || null;
  }

  function ensureGuide(panel) {
    let guide = panel.querySelector('.wcf-measurement-guide');
    if (guide) return guide;
    const body = panel.querySelector('.expo-steps-overlay__body');
    if (!body) return null;
    guide = document.createElement('aside');
    guide.className = 'wcf-measurement-guide';
    guide.setAttribute('aria-label', 'Body measurement example');
    const picture = document.createElement('img');
    picture.alt = 'Before you measure';
    picture.src = images.before;
    picture.loading = 'eager';
    picture.decoding = 'async';
    guide.appendChild(picture);
    panel.insertBefore(guide, body);
    return guide;
  }

  function showField(panel, wrapper, label) {
    const guide = ensureGuide(panel);
    if (!guide) return;
    const key = imageKeyFor(label);
    if (!key || !images[key]) {
      guide.hidden = true;
      return;
    }
    const picture = guide.querySelector('img');
    if (picture.src !== images[key]) picture.src = images[key];
    picture.alt = `${fieldNames[key]} measurement example`;
    guide.hidden = false;
    if (window.matchMedia('(max-width: 749px)').matches && wrapper) {
      wrapper.appendChild(guide);
      guide.classList.add('wcf-measurement-guide--inline');
    } else {
      if (guide.parentElement !== panel) {
        panel.insertBefore(guide, panel.querySelector('.expo-steps-overlay__body'));
      }
      guide.classList.remove('wcf-measurement-guide--inline');
    }
  }

  function scan() {
    document.querySelectorAll('.expo-steps-overlay--modal .expo-steps-overlay__panel')
      .forEach(ensureGuide);
  }

  function onFocus(event) {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const wrapper = target.closest('.expo-element-wrapper');
    const overlay = target.closest('.expo-steps-overlay--modal');
    if (!wrapper || !overlay) return;
    const panel = overlay.querySelector('.expo-steps-overlay__panel');
    const label = wrapper.querySelector('.expo-element-label');
    if (panel && label) showField(panel, wrapper, label.textContent);
  }

  function start() {
    scan();
    document.addEventListener('focusin', onFocus, true);
    const observer = new MutationObserver(scan);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
